import 'reactjs-popup/dist/index.css';

import React from 'react';
import Popup from 'reactjs-popup';

import popupStyles from '../lib/Popup.scss';
import styles from './footer.scss';

const links = () => (
  <div className={styles.right}>
    <Popup trigger={<span className={styles.links}>Contact</span>} modal closeOnDocumentClick>
      <div>
        <div className={popupStyles.header}>Contact</div>
        <div className={`${popupStyles.content} ${styles.popup}`}>
          <p>Climate Change Adaptation Center, National Institute for Environmental Studies</p>
          <p>ccca-scenario@nies.go.jp</p>
        </div>
      </div>
    </Popup>
    <a className={styles.links} href="https://www.nies.go.jp/kojinjoho/privacypolicy.html" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    <a className={styles.links} href="http://www.nies.go.jp/sitepolicy.html" target="_blank" rel="noopener noreferrer">
      Site Policy
    </a>
  </div>
);

export default function footer({topPage=false}={}) {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        {topPage && links()}
      </div>

      <div className={styles.copy}>
        Copyright &copy; National Institute for Environmental Studies. All Rights Reserved.
      </div>
    </footer>
  );
}
